'use strict';

// converted from https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
var componentToHex = function (c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
};
var rgbValuesToHex = function (r, g, b) {
    return ("#" + componentToHex(r) + componentToHex(g) + componentToHex(b)).toUpperCase();
};
var rgbToHex = function (rgb) {
    return rgbValuesToHex(rgb.r, rgb.g, rgb.b);
};
var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex !== null && hex !== void 0 ? hex : '');
    if (!result) {
        return {
            r: 0,
            g: 0,
            b: 0,
        };
    }
    return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    };
};
var PERCENT_DARKER = 10;
var getRgbValue = function (variant, darknessLevel) {
    var percentDarker = PERCENT_DARKER / 100;
    var darkness = percentDarker * darknessLevel;
    var value = variant * darkness + 255 * (1 - darkness);
    return Math.round(value);
};
var getRgbColor = function (rgb, darkness) {
    var r = getRgbValue(rgb.r, darkness);
    var g = getRgbValue(rgb.g, darkness);
    var b = getRgbValue(rgb.b, darkness);
    return "rgba(" + r + ", " + g + ", " + b + ", 1)";
};
var getRgbColorFromHex = function (hex, darkness) {
    var colorVariant = hexToRgb(hex);
    return getRgbColor(colorVariant, darkness);
};
var Colors = {
    rgbValuesToHex: rgbValuesToHex,
    rgbToHex: rgbToHex,
    hexToRgb: hexToRgb,
    getRgbValue: getRgbValue,
    getRgbColor: getRgbColor,
    getRgbColorFromHex: getRgbColorFromHex,
};

module.exports = Colors;
